import { Amplify } from 'aws-amplify';
import { isValidString } from '../common/CommonUtilsMethods';
import type { WorkyAmplifyCognitoEnvConfig } from './WorkyAmplifyConfigInterfaces';

const cognitoUserPoolId: string = process.env.REACT_APP_COGNITO_USER_POOL_ID ?? '';
const cognitoSpaClientId: string = process.env.REACT_APP_COGNITO_SPA_CLIENT_ID ?? '';
const cognitoRegion: string = process.env.REACT_APP_COGNITO_REGION ?? 'us-east-2';

let amplifyConfigured: boolean = false;

const readWorkyAmplifyCognitoEnvConfig = (): WorkyAmplifyCognitoEnvConfig | null => {
    if (!isValidString(cognitoUserPoolId) || !isValidString(cognitoSpaClientId)) {
        return null;
    }

    return {
        userPoolId: cognitoUserPoolId,
        userPoolClientId: cognitoSpaClientId,
        region: cognitoRegion,
    };
};

const configureWorkyAmplify = (): boolean => {
    if (amplifyConfigured) {
        return true;
    }

    const envConfig: WorkyAmplifyCognitoEnvConfig | null = readWorkyAmplifyCognitoEnvConfig();
    if (envConfig === null) {
        console.warn(
            'Worky Amplify config skipped: REACT_APP_COGNITO_USER_POOL_ID and REACT_APP_COGNITO_SPA_CLIENT_ID are required'
        );
        return false;
    }

    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: envConfig.userPoolId,
                userPoolClientId: envConfig.userPoolClientId,
                loginWith: {
                    username: false,
                    email: true,
                },
            },
        },
    });

    amplifyConfigured = true;
    return true;
};

const getWorkyAmplifySpaClientId = (): string => cognitoSpaClientId;

export { configureWorkyAmplify, getWorkyAmplifySpaClientId, readWorkyAmplifyCognitoEnvConfig };
